import { createAction } from 'redux-act';

import TimestampPayload from '../../TimestampPayload';

export interface FacebookPageUpdatedPayload extends TimestampPayload {
  placeUuid: string;
}

export const facebookPageUpdated = createAction<FacebookPageUpdatedPayload>('FACEBOOK_PAGE_UPDATED');
